import Button from "components/UI/Button";
import CollapsibleCard from "components/UI/CollapsibleCard";
import Container from "components/UI/Layout/Container";
import React, { useEffect, useState } from "react";
import MembersRepository from "services/repositories/MembersRepository";

function AuthenticationWidget() {
    const [connectButtonOptions, setConnectButtonOptions] = useState([]);

    const handleConnect = (urlToConnect) => {
        window.location.href = urlToConnect;
    };
    const handleDisconnect = async (
        urlToDisconnect,
        externalIdentifierType
    ) => {
        const repository = new MembersRepository();
        await repository.disconnect(externalIdentifierType);
        window.location.href = urlToDisconnect;
    };

    useEffect(() => {
        const getAuthenticationOptions = async () => {
            try {
                const repository = new MembersRepository();
                const result = await repository.getAuthenticationOptions();
                if (result.response.length > 0) {
                    setConnectButtonOptions(result.response);
                }
            } catch (err) {
                setConnectButtonOptions([]);
            }
        };
        getAuthenticationOptions();
    }, []);

    return (
        <>
            {connectButtonOptions.length > 0 && (
                <CollapsibleCard
                    title="Authentication"
                    storeId="auth_connections_profile"
                >
                    <Container className="tw-w-full tw-ml-3">
                        <p>
                            Connect your UJV Account with a third-party service
                            to use it for login
                        </p>

                        {connectButtonOptions.map((option, index) => (
                            <div key={index} className="tw-mb-4 tw-mt-4">
                                <Button
                                    color="primary"
                                    border={false}
                                    className="tw-flex tw-items-center tw-text-sm tw-px-5 tw-py-1"
                                    hideContentOnLoading
                                    margin="tw-ml-1"
                                    onClick={() =>
                                        handleConnect(option.auth_connect_url)
                                    }
                                    size="xs"
                                    disabled={option.connected}
                                >
                                    {option.option}
                                </Button>
                                {option.connected && (
                                    <button
                                        className="tw-text-xs tw-text-red-500 tw-mt-1 tw-ml-3 tw-bg-transparent tw-border-none tw-cursor-pointer"
                                        onClick={() =>
                                            handleDisconnect(
                                                option.auth_disconnect_url,
                                                option.option
                                            )
                                        }
                                    >
                                        Disconnect
                                    </button>
                                )}
                            </div>
                        ))}
                    </Container>
                </CollapsibleCard>
            )}
        </>
    );
}

export default AuthenticationWidget;
